<template>
  <div class="policy">
    <mt-header fixed title="共享经济合作伙伴协议" class="title">
      <mt-button slot="left" icon="back" @click="backClickHandler">返回</mt-button>
    </mt-header>
    <div v-html="hasMobileText"> </div>
  </div>
</template>

<script>
export default {
  /* global PUBLIC_SHARE_TEXT,PUBLIC_PRODUCT */
  name: 'Share',
  data() {
    return {
      mobile: '（010-962909）',
      shareText: PUBLIC_SHARE_TEXT,
      product: PUBLIC_PRODUCT.toLowerCase().trim(),
    };
  },
  computed: {
    hasMobileText() {
      if (this.product === 'cxplus' || this.product === 'cxpluszs') {
        return this.shareText.replace(/tmpCustomAppMobile/g, this.mobile);
      }
      return this.shareText.replace(/tmpCustomAppMobile/g, '');
    },
  },
  methods: {
    backClickHandler() {
      window.location.href = 'protocol://android';
    },
  },
};
</script>
